/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import axios from 'axios';
import * as actionTypes from './actionTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformRosiResolutionObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPUTE_DISPLAY_OBJ_ROSI,
  screenData: data,
});

export const setPaginationIndex = (data) => ({
  type: actionTypes.SET_PAGINATION_INDEX_ROSI_PQAS,
  payload: data,
});
//API call to get the labeler data
export const getLabelerList = async (values) => {
  try {
    const response = await axios.get(
      serviceEndPoint.GET_ALL_LABELER_LIST,
      values
    );
    if (response.data && response.data.data && response.data.data.length > 0) {
      return response.data.data;
      // eslint-disable-next-line no-else-return
    } else {
      return [];
    }
  } catch (e) {
    return [];
  }
};
// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformRosiDetailObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPUTE_DISPLAY_DETAIL_OBJ_ROSI,
  detailScrData: data,
});

// dispatch all labeler data
export const dispatchLabelerData = (data) => ({
  type: actionTypes.GET_ALL_LABELER_ROSI,
  payload: data,
});
//select option dispatch
export const getSelectedOption = (data) => ({
  type: actionTypes.SELECT_OPTION,
  payload: data,
});
//Manufactuerer Name Display
export const getManufactureName = (value) => ({
  type: actionTypes.GET_MANUFACTURER_NAME_ROSI,
  allManufacturer: value,
});
//Manufacturer ID display
export const getManufactureID = (value) => ({
  type: actionTypes.GET_MANUFACTURER_ID_ROSI,
  manufactureWithIds: value,
});
// plan Type dispatch
export const dispatchPlanType = (data) => ({
  type: actionTypes.GET_PLAN_TYPE_DATA_ROSI,
  payload: data,
});
//  error msg dispatch function
export const dispatchErrorMsgRosi = (data) => ({
  type: actionTypes.GET_ERROR_MSG_ROSI,
  payload: data,
});
// error message for 5 sec for no data exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  // dispatch(dispatchErrorMsgRosi({ searchScreenErrors: [] }));
  // }, 5000);
  dispatch(
    dispatchErrorMsgRosi({
      searchScreenErrors: [
        {
          field: 'noData',
          message: NO_DATA,
        },
      ],
    })
  );
};

export const dispatchFromRosi = (data) => ({
  type: actionTypes.GET_FROM,
  payload: data,
});
//dispatch rosi grid
export const dispatchRosiGrid = (data) => ({
  type: actionTypes.GET_ROSI_GRID_DATA,
  payload: data,
});
export const dispatchPqasGrid = (data) => ({
  type: actionTypes.GET_PQAS_GRID_DATA,
  payload: data,
});
// To dispatch plantype data
export const getPlanTypeValues = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(dispatchPlanType([]));
    });
};
// rebate programe dispatch function
export const dispatchRebatePrograme = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_ROSI,
  payload: data,
});
//on toggle rebate program
export const dispatchRebateProgramName = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_NAME_ROSI,
  payload: data,
});
//  get rebate programe function
export const getRebateProgrameList = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data;
    })
    .catch((response) => {});
};

// manufacturer griddispatch (display screen)
export const dispatchMfgGrid = (data) => ({
  type: actionTypes.GRID_MFG_ROSI,
  payload: data,
});
// NDC grid dispatch
export const dispatchNdcGrid = (data) => ({
  type: actionTypes.GRID_NDC_ROSI,
  payload: data,
});
//dispatch index
export const dispatchIndex = (data) => ({
  type: actionTypes.GET_INDEX,
  payload: data,
});
//drug data dispatch
export const dispatchDrugData = (data) => ({
  type: actionTypes.GET_DRUG_DATA_ROSI,
  payload: data,
});
//drug data dispatch
export const dispatchSearchType = (data) => ({
  type: actionTypes.SELECT_SEARCH_TYPE,
  payload: data,
});
//Manufacturer Grid
export const getManufacturerList = (values) => (dispatch) => {
  return axios
    .post(
      `${serviceEndPoint.REBATE_PERCENT_OF_SPEND_MANUFACTURER_GRID}`,
      values
    )
    .then((response) => {
      return dispatch({
        type: actionTypes.MANUFACTURER_GRID_ROSI,
        manufacturerList: response.data,
      });
    })
    .catch((response) => {
      dispatch([]);
      return response;
    });
};

//ndc grid
export const getNDCGrid = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.DISPUTE_ACTIVITY_GRID_NDC, value)
    .then((response) => {
      return dispatch(dispatchNdcGrid(response.data));
    })
    .catch((response) => {
      dispatch(dispatchNdcGrid([]));
    });
};
//rosi grid
export const getRosiGrid = (value) => (dispatch) => {
  dispatch(dispatchRosiGrid([]));
  return axios
    .post(serviceEndPoint.GET_ROSI_GRID, value)
    .then((response) => {
      if (response.data.rosiPqasRosiGridVO.length == 0) {
        dispatch(showNoDataMessage());
      } else {
        dispatch(dispatchRosiGrid(response.data));
      }
    })
    .catch((response) => {
      dispatch(dispatchRosiGrid([]));
    });
};
//pqas grid
export const getPqasGrid = (value) => (dispatch) => {
  dispatch(dispatchPqasGrid([]));
  return axios
    .post(serviceEndPoint.GET_PQAS_GRID, value)
    .then((response) => {
      if (response.data.rosiPqasReportPqasGridVOList.length == 0) {
        // dispatch(showNoDataMessage());
      } else {
        dispatch(dispatchPqasGrid(response.data));
      }
    })
    .catch((response) => {
      dispatch(dispatchPqasGrid([]));
    });
};
//refresh data
export const refreshRosiPqas = () => ({
  type: actionTypes.SET_REFRESH_DATA_ROSI,
  payload: {},
});
export const refreshRosiPqasDisplay = () => ({
  type: actionTypes.SET_REFRESH_DATA_ROSI_DISPLAY,
  payload: {},
});
export const getExportRosiGrid =
  ({
    mfgTypeCd,
    rebateProgramCd,
    mfgId,
    drugSeqNum,
    qtr,
    startDate,
    familySeqNum,
  }) =>
  (dispatch) => {
    // dispatch(setDisputeActivityExportAll({}));
    // let allNDCID = drugDataList?.map((item) => item.drugSeqNum);
    // const arr = divideArray(allNDCID, 4);
    // for (let i = 0; i < arr.length; i++) {
    //   const values = {
    //     rebateProgramCD,
    //     drugSeqNum: arr[i],
    //     disputeCode,
    //     openStatus,
    //     closeStatus,
    //   };
    //   dispatch(reportNDCData(values, i));
  };
export const dispatchErrorMsgNDCDetail = (data) => ({
  type: actionTypes.GET_ERROR_MSG_NDC_DETAILS,
  payload: data,
});
// dispatch Display screen Object
export const dispatchDisplayObjRosi = (data) => ({
  type: actionTypes.SET_DISPLAY_OBJ_ROSI,
  payload: data,
});
